import Api from './api.js'

function reportShare(source, openid) {
  // Api.post('/shanzhadao/report_share', {source: source, openid: openid}, res => {
  //   // if(res.code == 200){
  //   //   console.log('reportShare success, msg: ' + res.msg)
  //   // }
  // })
}

export default {
  reportShare: function (source, openid) {
    return reportShare(source, openid)
  }
}
